import apiCityCenter from "@/services/cityCenter/api/apiCityCenter";

import {
  SET_NOTIFICATIONS,
  SET_DASHBOARD_ANNOUNCEMENTS,
  SET_DASHBOARD_UPCOMING_EVENTS,
  SET_USER_MANAGEMENT,
  SET_ROLE_GROUP,
  SET_ROLE_GROUP_ASSOCIATION,
  SET_ROLES,
  SET_APPLICATION_LIST,
  SET_APPLICATION_CONTRACT_LIST,
  SET_USER_ASSOCIATED_ROLE_GROUPS,
  SET_SEARCHED_ROLE_GROUPS,
  SET_ASSOCIATED_ROLES,
  SET_ASSOCIATION_TYPES,
  SET_EMPLOYEE_ASSOCIATIONS,
  SET_PROCESS_TYPES,
  SET_WORKFLOWS,
  SET_ACTIONS,
  SET_PROCESS_ASSOCIATIONS,
  SET_USER_GROUPS,
  SET_USERS_IN_USER_GROUP,
  SET_AVAILABLE_STATUS,
  SET_STATUS_CONFIGURATION,
  SET_USER_GROUP_ASSOCIATION,
  SET_SEARCHED_USER_LIST,
  SET_APPROVAL_GROUPS,
  SET_USERS_IN_APPROVAL_GROUP,
  SET_ASSOCIATED_USER_GROUPS_WITH_APPROVAL_GROUP,
  SET_AVAILABLE_NEXT_STATUS
} from "@/store/cityCenter/mutation-types";
import notifications from "@/data/shared/notifications.json";
import dashboardAnnouncements from "@/data/cityCenter/dashboard/announcements.json";
import dashboardUpcommingEvents from "@/data/cityCenter/dashboard/upcommingEvents.json";
import { handleError } from "@/store/shared";
const endpoints = require("../../common/endpoints");

const actions = {
  /**
   * set cityCenter Notifications
   * @param commit
   * @param {String} payload
   * @returns {Promise<void>}
   */
  async setNotifications({ commit }, payload) {
    console.log("setNotifications().payload:", payload);
    commit(SET_NOTIFICATIONS, notifications);
  },
  async setDashboardAnnouncements({ commit }, payload) {
    console.log("setDashboardAnnouncements().payload:", payload);

    return apiCityCenter
      .getPersonnelActions()
      .then(response => {
        const data = response.data;
        commit(SET_DASHBOARD_ANNOUNCEMENTS, dashboardAnnouncements);
        return data;
      })
      .catch(error =>
        handleError(error, `Unable to set Dashboard Announcements`)
      );
  },
  async setDashboardUpcomingEvents({ commit }, payload) {
    console.log("setDashboardUpcomingEvents().payload:", payload);

    return apiCityCenter
      .getPersonnelActions()
      .then(response => {
        const data = response?.data;
        commit(SET_DASHBOARD_UPCOMING_EVENTS, dashboardUpcommingEvents);
        return data;
      })
      .catch(error =>
        handleError(error, `Unable to set Dashboard Upcoming Events`)
      );
  },
  async setUserManagement({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.get_users_list + payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_USER_MANAGEMENT, data);
      })
      .catch(error => handleError(error, `Unable to set User Management`));
  },
  async setRoleGroup({ commit }, payload) {
    return apiCityCenter
      .get(endpoints?.get_roles, payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_ROLE_GROUP, data);
      })
      .catch(error => handleError(error, `Unable to set Role Group`));
  },
  async setRoleGroupAssociation({ commit }, payload) {
    return apiCityCenter
      .get(endpoints?.get_user_role_assignment, payload)
      .then(response => {
        const data = response?.data;
        commit(SET_ROLE_GROUP_ASSOCIATION, data);
      })
      .catch(error =>
        handleError(error, `Unable to set Role Group Association`)
      );
  },
  async setRoles({ commit }, payload) {
    return apiCityCenter
      .get(endpoints?.get_user_role_permissions, payload)
      .then(response => {
        const data = response?.data;
        commit(SET_ROLES, data);
      })
      .catch(error => handleError(error, `Unable to set Roles`));
  },
  async setApplicationList({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.get_application_list, payload)
      .then(response => {
        const data = response?.data;
        commit(SET_APPLICATION_LIST, data);
      })
      .catch(error => handleError(error, `Unable to set Applications List`));
  },
  async setApplicationContractList({ commit }, payload) {
    return apiCityCenter
      .get(endpoints?.get_user_application_contract_list, payload)
      .then(response => {
        const data = response?.data;
        commit(SET_APPLICATION_CONTRACT_LIST, data);
      })
      .catch(error =>
        handleError(error, `Unable to set Application Contract List`)
      );
  },
  async setUserAssociatedRoleGroups({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.get_user_associated_role_groups + payload)
      .then(response => {
        const data = response?.data;
        commit(SET_USER_ASSOCIATED_ROLE_GROUPS, data);
      })
      .catch(error =>
        handleError(error, `Unable to set User Associated Role Groups`)
      );
  },
  async setSearchedRoleGroups({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints.get_searched_role_groups + payload)
      .then(response => {
        const data = response?.data;
        commit(SET_SEARCHED_ROLE_GROUPS, data);
      })
      .catch(error => handleError(error, `Unable to set Searched Role Groups`));
  },
  async setAssociatedRoles({ commit }, payload) {
    return apiCityCenter
      .get(endpoints.get_user_role_permissions, payload)
      .then(response => {
        const data = response?.data;
        commit(SET_ASSOCIATED_ROLES, data);
      })
      .catch(error => handleError(error, `Unable to set Associated Roles`));
  },
  async setAssociationTypes({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.get_association_types, payload)
      .then(response => {
        const data = response?.data;
        commit(SET_ASSOCIATION_TYPES, data);
      })
      .catch(error => handleError(error, `Unable to set Association Types`));
  },
  async setEmployeeAssociations({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.employee_association + payload)
      .then(response => {
        const data = response?.data;
        commit(SET_EMPLOYEE_ASSOCIATIONS, data);
      })
      .catch(error =>
        handleError(error, `Unable to set Employee Associations`)
      );
  },
  async setSearchedUserList({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.get_searched_user_list + payload)
      .then(response => {
        const data = response?.data;
        commit(SET_SEARCHED_USER_LIST, data);
      })
      .catch(error => handleError(error, `Unable to set Searched User List`));
  },
  async setProcessTypes({ commit }, payload) {
    return apiCityCenter
      .wfApiGet(endpoints?.process_type, payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_PROCESS_TYPES, data);
      })
      .catch(error => handleError(error, `Unable to set Process Types`));
  },
  async setWorkflows({ commit }, payload) {
    return apiCityCenter
      .wfApiGetWithoutPayload(endpoints?.workflow_defs, payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_WORKFLOWS, data);
      })
      .catch(error => handleError(error, `Unable to set Workflows`));
  },
  async setActions({ commit }, payload) {
    return apiCityCenter
      .wfApiGet(endpoints?.workflow_actions, payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_ACTIONS, data);
      })
      .catch(error => handleError(error, `Unable to set Actions`));
  },
  async setProcessAssociations({ commit }, payload) {
    return apiCityCenter
      .wfApiGetWithoutPayload(endpoints?.workflow_association, payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_PROCESS_ASSOCIATIONS, data);
      })
      .catch(error => handleError(error, `Unable to set Process Associations`));
  },
  async setUserGroups({ commit }, payload) {
    return apiCityCenter
      .get(endpoints?.user_group, payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_USER_GROUPS, data);
      })
      .catch(error => handleError(error, `Unable to set User Groups`));
  },
  async setUsersInUserGroup({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.user_group_membership + payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_USERS_IN_USER_GROUP, data);
      })
      .catch(error => handleError(error, `Unable to set Users in User Group`));
  },
  async setUserGroupAssociation({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.user_group_association + payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_USER_GROUP_ASSOCIATION, data);
      })
      .catch(error =>
        handleError(error, `Unable to set User Group Association`)
      );
  },
  async setAvailableStatus({ commit }, payload) {
    return apiCityCenter
      .wfApiGetWithoutPayload(endpoints?.status + payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_AVAILABLE_STATUS, data);
      })
      .catch(error => handleError(error, `Unable to set Available Status`));
  },
  async setStatusConfiguration({ commit }, payload) {
    return apiCityCenter
      .wfApiGetWithoutPayload(endpoints?.status_configuration, payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_STATUS_CONFIGURATION, data);
      })
      .catch(error => handleError(error, `Unable to set Status Configuration`));
  },
  async setApprovalGroups({ commit }, payload) {
    return apiCityCenter
      .get(endpoints?.approval_group, payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_APPROVAL_GROUPS, data);
      })
      .catch(error => handleError(error, `Unable to set Approval Groups`));
  },
  async setUsersInApprovalGroup({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(endpoints?.approval_group_association + payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_USERS_IN_APPROVAL_GROUP, data);
      })
      .catch(error =>
        handleError(error, `Unable to set Users in Approval Group`)
      );
  },
  async setAssociatedUserGroupsWithApprovalGroup({ commit }, payload) {
    return apiCityCenter
      .getWithoutPayload(
        endpoints?.approval_group_to_user_group_association + payload
      )
      .then(response => {
        const data = response?.data?.data;
        commit(SET_ASSOCIATED_USER_GROUPS_WITH_APPROVAL_GROUP, data);
      })
      .catch(error =>
        handleError(
          error,
          `Unable to set Associated User Groups with Approval Group`
        )
      );
  },
  async setAvailableNextStatus({ commit }, payload) {
    return apiCityCenter
      .wfApiGetWithoutPayload(endpoints?.next_available_status + payload)
      .then(response => {
        const data = response?.data?.data;
        commit(SET_AVAILABLE_NEXT_STATUS, data);
      })
      .catch(error =>
        handleError(error, `Unable to set Available Next Status`)
      );
  }
};

export default actions;
